<template>
<div>
    <AppBar />

    <!-- HERO SECTION -->
    <section class="who-hero">
        <v-container class="text-center">
            <h1 class="hero-title">{{ $t('HeroAboutUs.Title') }}</h1>
            <p class="hero-subtitle">{{ $t('HeroAboutUs.Subtitle') }}</p>
        </v-container>
    </section>

    <!-- VISION & MISSION -->
    <section class="vision-mission">
        <v-container fluid>
            <v-row justify="center" align="stretch" class="gap-20">
                <!-- Vision -->
                <v-col cols="12" md="6" lg="5">
                    <v-card class="vm-card horizontal-card d-flex elevation-0">
                        <div class="card-image">
                            <img :src="require('@/assets/vision1.jpg')" alt="Vision" loading="lazy" />
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">{{ $t('VisionMission.VisionTitle') }}</h3>
                            <p class="card-text">{{ $t('VisionMission.VisionText') }}</p>
                        </div>
                    </v-card>
                </v-col>

                <!-- Mission -->
                <v-col cols="12" md="6" lg="5">
                    <v-card class="vm-card horizontal-card d-flex elevation-0">
                        <div class="card-image">
                            <img :src="require('@/assets/mission.jpg')" alt="Mission" loading="lazy" />
                        </div>
                        <div class="card-content">
                            <h3 class="card-title">{{ $t('VisionMission.MissionTitle') }}</h3>
                            <p class="card-text">{{ $t('VisionMission.MissionText') }}</p>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </section>

    <!-- TEAM -->
    <!-- ================= TEAM SECTION ================= -->
    <section class="team-section" v-if="teamMembers.length">
        <v-container>

            <!-- Title -->
            <h2 class="section-title text-center">
                {{ $t('TeamSection.Title') }}
            </h2>

            <p class="team-intro text-center">
                {{ $t('TeamSection.Intro') }}
            </p>

            <!-- Slider -->
            <div class="team-wrapper">
                <div class="team-track">

                    <!-- ORIGINAL -->
                    <div v-for="(member, index) in teamMembers" :key="'orig-' + index" class="team-slide" @click="openDialog(member)">
                        <div class="team-card">
                            <div class="avatar-wrapper">
                                <v-img :src="getImageUrl(member.image)" :alt="member.name" class="avatar"  />
                            </div>

                            <div class="team-content">
                                <h3 class="team-name">{{ member.name }}</h3>
                                <p class="team-role">
                                    {{ selectedLanguagePosition(member) }}
                                </p>

                                <p class="view-bio">
                                    {{ $t('TeamSection.ViewBio') }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- DUPLICATE (for infinite scroll) -->
                    <div v-for="(member, index) in teamMembers" :key="'dup-' + index" class="team-slide" @click="openDialog(member)">
                        <div class="team-card">
                            <div class="avatar-wrapper">
                                <v-img :src="getImageUrl(member.image)" :alt="member.name" class="avatar" cover />
                            </div>

                            <div class="team-content">
                                <h3 class="team-name">{{ member.name }}</h3>
                                <p class="team-role">
                                    {{ selectedLanguagePosition(member) }}
                                </p>

                                <p class="view-bio">
                                    {{ $t('TeamSection.ViewBio') }}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- ================= BIO DIALOG ================= -->
        <!-- BIO DIALOG -->
            <v-dialog v-model="dialog" max-width="750" transition="scale-transition">
                <v-card class="bio-card">
                    <div class="bio-header">
                        <div class="bio-avatar">
                            <v-img :src="getImageUrl(selectedMember.image)" :alt="selectedMember.name" />
                        </div>
                    </div>

                    <v-card-text>
                        <h2 class="bio-name">{{ selectedMember.name }}</h2>
                        <p class="bio-role">{{ translatedPosition }}</p>
                        <p class="bio-text">{{ translatedBio }}</p>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                        <v-btn color="#2e7d32" variant="flat" rounded="xl" @click="dialog = false">
                            {{ $t('TeamSection.CloseButton') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- ================= END DIALOG ================= -->

        </v-container>
    </section>
    <!-- ================= END TEAM SECTION ================= -->
    <!-- FAQ -->
    <section class="faq-section">
        <v-container>
            <!-- Translated Title & Intro -->
            <h2 class="section-title text-center">{{ faqTitle }}</h2>
            <p class="faq-intro text-center mb-8">{{ faqIntro }}</p>

            <!-- FAQ Items -->
            <v-expansion-panels variant="accordion" class="faq-panels elevation-0">
                <v-expansion-panel v-for="(faq, i) in faqItems" :key="i" class="faq-panel">
                    <v-expansion-panel-title expand-icon="mdi-menu-down" collapse-icon="mdi-menu-up">
                        <v-icon color="#2e7d32" class="mr-2">{{ faq.icon }}</v-icon>
                        {{ $t(faq.questionKey) }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <p class="faq-answer white-space-pre-line">{{ $t(faq.answerKey) }}</p>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>

        </v-container>
    </section>

    <Footer />
</div>
</template>

<script>
import axios from "axios";
import Footer from "../Layout/Footer";
import AppBar from "../Layout/appBar";
// import i18n from '@/i18n';

export default {
    components: {
        Footer,
        AppBar
    },
    data() {
        return {
            dialog: false,
            selectedMember: {},
            teamMembers: [],
            faqItems: [{
                    questionKey: "FAQ.Items.Q1.question",
                    answerKey: "FAQ.Items.Q1.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q2.question",
                    answerKey: "FAQ.Items.Q2.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q3.question",
                    answerKey: "FAQ.Items.Q3.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q4.question",
                    answerKey: "FAQ.Items.Q4.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q5.question",
                    answerKey: "FAQ.Items.Q5.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q6.question",
                    answerKey: "FAQ.Items.Q6.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q7.question",
                    answerKey: "FAQ.Items.Q7.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q8.question",
                    answerKey: "FAQ.Items.Q8.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q9.question",
                    answerKey: "FAQ.Items.Q9.answer",
                    icon: "mdi-help-circle"
                },
                {
                    questionKey: "FAQ.Items.Q10.question",
                    answerKey: "FAQ.Items.Q10.answer",
                    icon: "mdi-help-circle"
                }
            ]

        };
    },
    computed: {
        faqTitle() {
            return this.$t('FAQ.Title');
        },
        faqIntro() {
            return this.$t('FAQ.Intro');
        },

        translatedPosition() {
            if (!this.selectedMember.position) return '';
            const lang = this.$i18n.locale || 'en';
            return this.selectedMember.position[lang] || this.selectedMember.position['en'] || '';
        },
        translatedBio() {
            if (!this.selectedMember.bio) return '';
            const lang = this.$i18n.locale || 'en';
            return this.selectedMember.bio[lang] || this.selectedMember.bio['en'] || '';
        }

    },
    methods: {
        openDialog(member) {
            this.selectedMember = member;
            this.dialog = true;
        },
        selectedLanguagePosition(member) {
            if (!member.position) return '';
            const lang = this.$i18n.locale || 'en';
            return member.position[lang] || member.position['en'] || '';
        },

        fetchItems() {
            axios.get('/published-team')
                .then(response => {
                    this.teamMembers = response.data.data;
                    console.log(this.teamMembers);
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        },
        getImageUrl(imageName) {
            return this.$getImageUrl(imageName);
        },
        getStatusColor(status) {
            if (!status) return "grey";
            const lower = status.toLowerCase();
            switch (lower) {
                case "pending":
                    return "orange";
                case "published":
                    return "green";
                default:
                    return "grey";
            }
        },
        startAutoSlide() {
            setInterval(() => {
                const slider = this.$refs.processSlider;
                if (slider && slider.next) {
                    slider.next();
                }
            }, 3000); // slides every 3 seconds
        },

    },
    async mounted() {
        this.fetchItems();
        this.startAutoSlide();

        // Load messages for current locale dynamically if needed
        //    this.loadFaq(i18n.global.locale); // ✔ works always
    }
};
</script>

<style scoped>
/* HERO */
.who-hero {
    background: #2e7d32;
    color: #fff;
    padding: 6rem 1rem;
    text-align: center;
}

.hero-subtitle {
    font-size: 1.25rem;
    max-width: 780px;
    margin: 0 auto;
    line-height: 1.8;
    font-style: italic;
}

/* VISION & MISSION */
.vision-mission {
    padding: 6rem 0;
}

.white-space-pre-line {
    white-space: pre-line;
}

.vm-card.horizontal-card {
    display: flex;
    border-radius: 20px;
    overflow: hidden;
    background: linear-gradient(135deg, #e6f1f0, #f1f1f1);
    gap: 10px;
    height: 250px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.vm-card.horizontal-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.card-image {
    width: 40%;
}

.card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-content {
    width: 60%;
    padding: 1.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.card-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2e7d32;
}

.card-text {
    color: #555;
    line-height: 1.8;
}

/* Responsive */
@media (max-width: 960px) {
    .vm-card.horizontal-card {
        flex-direction: column;
        height: auto;
    }

    .card-image {
        width: 100%;
        height: 180px;
    }

    .card-content {
        width: 100%;
        padding: 1rem 1.5rem;
    }
}

/* TEAM */
/* TEAM WRAPPER */
.team-wrapper {
    overflow: hidden;
    position: relative;
    padding: 3rem 0;
}

/* SLIDING TRACK */
.team-track {
    display: flex;
    gap: 40px;
    animation: scrollTeam 35s linear infinite;
}

/* EACH SLIDE */
.team-slide {
    min-width: 280px;
    max-width: 280px;
    flex-shrink: 0;
}

/* CARD */
.team-card {
    height: 380px;
    /* Equal height for all cards */
    background: #fff;
    border-radius: 25px;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    /* Even spacing */
    text-align: center;
    /* box-shadow: 0 15px 40px rgba(46, 125, 50, 0.15); */
    transition: all 0.4s ease;
    cursor: pointer;
}

.team-card:hover {
    transform: translateY(-12px);
    box-shadow: 0 25px 60px rgba(46, 125, 50, 0.25);
}

/* IMAGE */
.avatar-wrapper {
    width: 130px;
    height: 130px;
    margin: 1rem auto;
    border-radius: 50%;
    overflow: hidden;
    border: 6px solid #fff;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.avatar {
     width: 100%;
    height: 100%;
    object-fit: contain;
}

/* CONTENT AREA */
.team-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* NAME */
.team-name {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
}

/* ROLE */
.team-role {
    font-size: 0.9rem;
    color: #666;
    margin: 0;
}
.team-intro{
		max-width: 700px;
		margin: 0 auto 3rem;
		font-size: 1.1rem;
		color: #666;
		font-style: italic;
}

/* VIEW BIO */
.view-bio {
    margin-top: 10px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #2e7d32;
    opacity: 0.8;
    transition: opacity 0.3s ease;
}

.team-card:hover .view-bio {
    opacity: 1;
}

/* ANIMATION */
@keyframes scrollTeam {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-50%);
    }
}

.v-row>.v-col {
    display: flex;
    /* makes column fill same height */
}

.v-row>.v-col>.team-card {
    flex: 1;
    /* makes cards in row equal height */
}

.team-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 18px 55px rgba(46, 125, 50, 0.22);
}

.avatar-wrapper {
    width: 130px;
    height: 130px;
    margin: 1rem auto;
    border-radius: 50%;
    overflow: hidden;
    border: 6px solid #fff;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.avatar {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.team-name {
    font-weight: 700;
    color: #2e7d32;
    margin-top: 0.5rem;
}

.team-role {
    font-size: 0.95rem;
    color: #777;
}

.view-bio {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    color: #b87c4c;
    font-style: italic;
}

/* BIO */
.bio-card {
    border-radius: 20px;
}

.bio-header {
    background: linear-gradient(135deg, #2e7d32, #b87c4c);
    height: 150px;
    position: relative;
}

.bio-avatar {
    position: absolute;
    left: 50%;
    bottom: -60px;
    transform: translateX(-50%);
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    border: 6px solid #fff;
}

.bio-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.bio-name {
    margin-top: 80px;
    font-size: 1.5rem;
    font-weight: 800;
    text-align: center;
    color: #2e7d32;
}

.bio-role {
    text-align: center;
    color: #777;
    margin-bottom: 1rem;
    font-style: italic;
}

.bio-text {
    color: #444;
    line-height: 1.6;
    text-align: justify;
}

/* FAQ */
.faq-section {
    padding: 4rem 0;
}

.faq-intro {
    max-width: 700px;
    margin: 0 auto 3rem;
    font-size: 1.1rem;
    color: #666;
    font-style: italic;
}

.faq-panels {
    max-width: 900px;
    margin: 0 auto;
}

.faq-panel {
    margin-bottom: 0.3rem;
    border-radius: 12px;
    border: 1px solid #f0eeee;
    background: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.faq-panel:hover {
    box-shadow: 0 8px 24px rgba(46, 125, 50, 0.15);
}

.faq-question {
    font-weight: 600;
    color: #686968;
}

.faq-answer {
    color: #555;
    line-height: 1.6;
}
</style>
